import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Calque_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 841.89 595.28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(".st0{fill:#185a7d}.st1{fill:#636569}", -1)
      ]))]),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m444.38 227.49-6.05-77.64L694.12 17.09l2.43 85.1zM452.34 255.66l73.21-26.62 11.98 336.1-90.52.67zM552.17 304.24l2 63.9 145.09-64.56-2-171.72-53.24 27.29 3.33 103.83z",
      class: "st0"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "m397.51 229.46 6.05-77.64L147.77 19.06l-2.43 85.1zM389.55 257.63l-73.21-26.62-11.98 336.1 90.52.67zM289.72 306.21l-2 63.9-145.09-64.56 2-171.71 53.24 27.28-3.33 103.83z",
      class: "st1"
    }, null, -1))
  ]))
}
export default { render: render }